export interface ICreditCard {
  id: number
  number: string
  type: 'VISA' | 'MASTER_CARD' | 'AMERICAN_EXPRESS' | 'UNKNOWN'
  storageType?: PaymentChannel
}

export interface ICreditCardSettings {
  paymentChannel: PaymentChannel
  apiLogin: string
  authorizePublicClientKey: string
}

export interface ICreditCardsConfig {
  creditCardSettings: Array<ICreditCardSettings>
  creditCards: Array<ICreditCard>
}

export enum PaymentChannel {
  AuthorizeNet = 'AUTHORIZE_NET',
}
